<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-02-29 10:50:48
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-14 16:22:40
 * @FilePath: /chaoyongtuan/src/views/contentLibray/LocalMaterial/LocalMaterial.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="main-content-padding">
		<Panel :content-padding-top="0">
			<el-tabs v-model="tabName" @tab-click="handleClick">
				<el-tab-pane v-for="item in tabList" :name="item.name" :label="item.label" :key="item.name"></el-tab-pane>
			</el-tabs>
			<div class="downloadBenefits fz-14 yx-color-g-9 pos-abso" style="top: 16px; right: 23px">
				<el-popover trigger="hover" popper-class="downloadBenefits" placement="bottom-end">
					<div style="margin: 0" class="flex-row p-8">
						<div v-if="downUseSizeMb">
							<div class="Barlow-SemiBold color-gy-9 fz-16 pb-4">{{ downUseSizeMb }}</div>
							<div class="font-h6-regular color-gy-7"> 累计下载消耗 </div>
						</div>
					</div>
					<div slot="reference" class="font-h6-regular cursor-pointer">
						<div>
							<img class="uchimura-icon" src="@/assets/public/uchimura-icon.png" alt="" />
							<span>储存空间：</span>
							{{ remainStorageSizeMb }} / {{ storageSizeMb }}
						</div>
					</div>
				</el-popover>
			</div>
			<Search class="mt-8" @onSubmit="onSubmit" ref="search" />
		</Panel>
		<Panel>
			<List ref="list" :materialType="tabName" :refreshKey="refreshStatus" @updateLeftSize="updateLeftSize" />
		</Panel>
	</div>
</template>
<script>
import Search from './components/search.vue';
import { getMaterialSource } from '@/api/contentLibray.js';
import List from './components/list.vue';
export default {
	data() {
		return {
			tabList: [
				{ label: '视频素材', name: '1' },
				{ label: '图片素材', name: '2' },
			],
			tabName: '1',

			storageSizeMb: '',
			remainStorageSizeMb: '',
			downUseNum: '',
			downUseSizeMb: '',
			downNum: null,
			downSize: null,
			refreshStatus: false,
		};
	},
	components: {
		Search,
		List,
	},
	methods: {
		handleClick() {
			this.$refs.search.onClear();
			this.refreshStatus = !this.refreshStatus;
		},
		onSubmit(params) {
			this.$refs.list.getList({ ...params, materialType: +this.tabName });
			this.refreshStatus = !this.refreshStatus;
		},
		// 更新剩余存储空间
		async updateLeftSize() {
			const { materialAvailableSize, materialTotalSize, materialDownloadUsedSize } = await getMaterialSource();
			this.storageSizeMb = materialTotalSize;
			this.remainStorageSizeMb = materialAvailableSize;
			this.downUseSizeMb = materialDownloadUsedSize;
		},
	},
	mounted() {
		this.updateLeftSize();
		this.$refs.search.onSubmit();
	},
};
</script>
<style lang="less">
.el-popover.el-popper.downloadBenefits {
	min-width: 112px !important;
}
.uchimura-icon {
	margin-bottom: 2px;
	margin-right: 6px;
	width: 16px;
	height: 16px;
}
</style>
